import { render, staticRenderFns } from "./gl-button-prime.vue?vue&type=template&id=41b20b3b"
import script from "./gl-button-prime.vue?vue&type=script&lang=js"
export * from "./gl-button-prime.vue?vue&type=script&lang=js"
import style0 from "./gl-button-prime.vue?vue&type=style&index=0&id=41b20b3b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports